// src/scripts/ServiceReports/ViewExterraSectionCard.js
import React from "react";
import {
  Card,
  CardHeader,
  CardContent,
  Typography,
  Stack,
  Grid,
} from "@mui/material";

const tidy = (v) => (v == null ? "" : String(v).trim());
const hasAny = (o, keys) => keys.some((k) => tidy(o?.[k]) !== "");

/**
 * View-only Exterra section
 * @param {Object} props
 * @param {Array<Object>} props.stations - Array of bait stations from jobOrder.exterra_bait_stations
 *   Each item can have: bait_station_no, location, status, action_taken
 */
export default function ViewExterraCard({ stations = [] }) {
  const list = (stations ?? []).filter((it) =>
    hasAny(it, ["bait_station_no", "location", "status", "action_taken"])
  );

  return (
    <Card variant="outlined" sx={{ mb: 2 }}>
      <CardHeader
        title={
          <Typography variant="h6" sx={{ fontWeight: "bold", textTransform: "uppercase" }}>
            If Exterra Client
          </Typography>
        }
        subheader="(up to 8 bait stations)"
        sx={{ pb: 0, px: 2, pt: 2 }}
      />
      <CardContent sx={{ px: 2, pb: 2 }}>
        {list.length ? (
          <Stack spacing={2}>
            {list.map((it, idx) => (
              <Card key={idx} variant="outlined" sx={{ borderStyle: "dashed" }}>
                <CardContent sx={{ py: 1.5 }}>
                  <Grid container spacing={1.5}>
                    {tidy(it.bait_station_no) && (
                      <Grid item xs={12} md={3}>
                        <Typography variant="caption" color="text.secondary" sx={{ display: "block" }}>
                          Bait Station #
                        </Typography>
                        <Typography variant="body2">{tidy(it.bait_station_no)}</Typography>
                      </Grid>
                    )}
                    {tidy(it.location) && (
                      <Grid item xs={12} md={3}>
                        <Typography variant="caption" color="text.secondary" sx={{ display: "block" }}>
                          Location
                        </Typography>
                        <Typography variant="body2">{tidy(it.location)}</Typography>
                      </Grid>
                    )}
                    {tidy(it.status) && (
                      <Grid item xs={12} md={3}>
                        <Typography variant="caption" color="text.secondary" sx={{ display: "block" }}>
                          Status
                        </Typography>
                        <Typography variant="body2">{tidy(it.status)}</Typography>
                      </Grid>
                    )}
                    {tidy(it.action_taken) && (
                      <Grid item xs={12} md={3}>
                        <Typography variant="caption" color="text.secondary" sx={{ display: "block" }}>
                          Action Taken
                        </Typography>
                        <Typography variant="body2">{tidy(it.action_taken)}</Typography>
                      </Grid>
                    )}
                  </Grid>
                </CardContent>
              </Card>
            ))}
          </Stack>
        ) : (
          <Typography variant="body2" color="text.secondary">
            No bait stations
          </Typography>
        )}
      </CardContent>
    </Card>
  );
}
